import { useTranslation } from "react-i18next";
import useCrudTable from "../../../../../hooks/useCrudTable";
import { TruckTableColumns } from "../../domain/columns/TruckTableColumns";
import { truckSchema } from "../../domain/schema/truckSchema";
import { useTranslatedColumns } from "../../../../general/modules/commons/tableTranslation/translatedColumns";
import useCrudFilters from "../../../../../hooks/useCrudFilters";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderActions,
  LayoutHeaderTitle,
} from "../../../../general/modules/commons/layout/layout";
import {
  Breadcrumb,
  BreadCrumbItem,
} from "../../../../general/modules/commons/breadcrumb/breadcrumb";
import { Content } from "../../../../general/modules/commons/content/content";
import { ContentHeader } from "../../../../general/modules/commons/content/contentHeader";
import { TruckTableFilters } from "../features/TruckTableFilters";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/useTypedSelector";
import { logout } from "../../../../auth/infrastructure/slices/authSlice/authSlice";

export const TruckPage = () => {
  const { t } = useTranslation("common");
  const dispatch = useAppDispatch();
  const title = t("Trucks");
  const currentUser = useAppSelector((state) => state.auth.user);

  const translatedColumns = useTranslatedColumns(TruckTableColumns);

  const crudFilters = useCrudFilters(
    {
      searchBy: "SearchByRootTruck",
      fields: {},
    },
    "truckFilter",
  );

  const crud = useCrudTable({
    prefix: "trucks",
    entity: "Truck",
    addAction: "/truck/add",
    columns: translatedColumns,
    schema: truckSchema,
    filters: crudFilters.filters,
    defaultSorting: [
      {
        id: "id",
        desc: true,
      },
    ],
  });

  if (!currentUser || currentUser.role === "dealer-employee") {
    return (
      <Layout>
        <LayoutContent>
          <Content>
            <ContentHeader className={"mt-3"} title={t("Access denied")} />
            <p className={"mt-3"}>{t("You don't have access to this page")}</p>
          </Content>
        </LayoutContent>
      </Layout>
    );
  }

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} />
          <Breadcrumb>
            <BreadCrumbItem>{title}</BreadCrumbItem>
          </Breadcrumb>
          <LayoutHeaderActions>{crud.addButton}</LayoutHeaderActions>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <Content>
          <ContentHeader title={title} className={"mb-3"} />
          <TruckTableFilters {...crudFilters} />
          {crud.table}
        </Content>
      </LayoutContent>
    </Layout>
  );
};
